import { Injectable } from '@angular/core';
import type { ModuleInterface } from '@zaoblako/shared/modules/security/dtos/access-control/module.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseService {
  protected baseUrl = '/role';

  public accessControlGet(id: number): Observable<ModuleInterface[]> {
    return this.http.get<ModuleInterface[]>(`${this.baseUrl}/${id}/access-control`);
  }

  public accessControlPut(id: number, body: ModuleInterface[]): Observable<ModuleInterface> {
    return this.http.put<ModuleInterface>(`${this.baseUrl}/${id}/access-control`, body);
  }
}
